export enum dialogType {
    channelsWindow = 'channels-window',
    AnalysisWindow = 'AnalysisBoard-window',
    search='search',
    colorPicker = 'color-picker',
    PlaybackMode = 'Playback Mode',
    SensorWindow='Sensor Window',
    showErrors='showErrors'
}